import React from 'react';
import Skills from './skills';
import About from './About';
import Blogs from './blogs';
import Contact from './contact';
import Testimonials from './testimonials';
import SideText from '../sidetext';
import Projects from './projects';
export default function SectionHandler(props) {
  if (props.input === '0') {
    return (
      <>
        <Blogs />
        <SideText text="BLOG" />
      </>
    );
  } else if (props.input === '1') {
    return (
      <>
        <About />
        <SideText text="ABOUT" />
      </>
    );
  } else if (props.input === '2') {
    return (
      <>
        <Testimonials />
        <SideText text="TESTIMONIALS" />
      </>
    );
  } else if (props.input === '3') {
    return (
      <>
        <Projects />
        <SideText text="PROJECTS" />
      </>
    );
  } else if (props.input === '4') {
    return (
      <>
        <Skills />
        <SideText text="SKILLS" />
      </>
    );
  } else if (props.input === '5') {
    return (
      <>
        <Contact />
        <SideText text="CONTACT" />
      </>
    );
  } else {
    return (
      <>
        <About />
        <SideText text="ABOUT" />
      </>
    );
  }
}
